export const trainingCentres = [
  'Barra do Pirai 1',
  'Barra do Pirai 2',
  'Cachoeiras de Macacu',
  'Trajano de Moraes',
  'Duas Barras',
  'Nova Friburgo',
  'Campo Grande 1',
  'Campo Grande 2',
  'Manguinhos 1',
  'Manguinhos 2',
  'Seropédica',
  'Valença 1',
  'Valença 2',
  'Santa Maria Madalena',
  'São Sebastiao do Alto',
  'Barra Mansa 1',
  'Barra Mansa 2',
  'Barra Mansa 3',
  'Teresópolis',
  'Sumidouro',
  'Vassouras',
  'São Gonçalo 1',
  'São Gonçalo 2',
  'São Goncalo 3',
  'Volta Redonda',
];
